import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {toast} from 'react-toastify';
import {extractLastCardNumbers} from "../../actions/InvoiceActions";
import {Formik} from "formik";
import {AddCreditCardSchema, EditCreditCardSchema} from './schemas';
import {BootstrapError, BootstrapField} from "../../helpers/Field";
import {ERROR_PAYMENT_METHOD} from "../../constants/ErrorMessages";
import moment from "moment";
import * as cardValidator from 'card-validator';
import {connect} from "react-redux";
import {faChevronDown} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export class AddCreditCardForm extends Component {
  constructor(props) {
    super(props);
    this.saveCard = this.saveCard.bind(this);
    this.buttonText = this.buttonText.bind(this);
    this.renderPaymentMethods = this.renderPaymentMethods.bind(this);
  }

  async saveCard(card) {
    this.props.save(card);
  }

  buttonText() {
    if(this.props.alwaysSaveOnFile){
    return this.props.isEditing ? "Update Card" : "Save Card";
    } else {
      return "Next";
    }
  }

  renderPaymentMethods(){
    return (<BootstrapField component="select" name="card_type" disabled={this.props.isEditing}>
      <option value={""}>Select Type</option>
      {this.props.paymentMethods.indexOf("VISA") !== -1 && <option value="VISA">Visa</option>}
      {this.props.paymentMethods.indexOf("MC") !== -1 && <option value="MC">Master Card</option>}
      {this.props.paymentMethods.indexOf("AMEX") !== -1 && <option value="AMEX">American Express</option>}
    </BootstrapField>)
  }
  
  render() {
    let initialValues = {
      card_type: "",
      card_name: "",
      card_number: "",
      card_validation_code: "",
      save_on_file: this.props.alwaysSaveOnFile,
      make_default: false,
    };
    let schema = AddCreditCardSchema;
    if (this.props.isEditing) {
      let date = moment(this.props.payment.valid_to, "MM-DD-YYYY");
      initialValues = {
        card_type: this.props.payment.payment_card_type,
        card_name: this.props.payment.payment_card_name,
        card_number: `ending in *${extractLastCardNumbers(this.props.payment.payment_card_token, '-')}`,
        card_validation_code: "",
        save_on_file: !this.props.payment.is_session,
        make_default: this.props.payment.isDefault,
        card_month: date.format("MM"),
        card_year: date.format("YYYY"),
      };
      schema = EditCreditCardSchema;
    }
    return <div>
      <div className="row">
        <div className="col-md-12">
          <Formik
            initialValues={initialValues}
            validationSchema={
              schema
            }
            validateOnChange={true}
            validate={(values) => {
              let errors = {};
              if ( !cardValidator.expirationDate({month: values.card_month, year: values.card_year}).isValid){
                errors.card_month = 'Invalid expiration date.';
              }
              return errors;
            }}
            enableReinitialize={true}
            onSubmit={(values, bag) => {
              bag.setSubmitting(true);
              this.saveCard(values).then((paymentcard) => {
                bag.setSubmitting(false);
                if (this.props.onCardConfirmed) {
                  this.props.onCardConfirmed(paymentcard);
                }
              }).catch(() => {
                toast.error(ERROR_PAYMENT_METHOD, {position: toast.POSITION.TOP_RIGHT});
                bag.setSubmitting(false);
              });
            }}
            render={(props) => (
              <form className='payment-form' onSubmit={props.handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className={"form-group customSelect"}>
                      {this.renderPaymentMethods()}
                      <FontAwesomeIcon icon={faChevronDown} className={"select-arrow"}/>
                      <BootstrapError name="card_type"/>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <BootstrapField type="text" name="card_name" placeholder="Name on Card"/>
                      <BootstrapError name="card_name"/>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <BootstrapField type="text" name="card_number" placeholder="Card Number"
                                      disabled={this.props.isEditing}/>
                      <BootstrapError name="card_number"/>
                    </div>
                  </div>
                </div>
                <div className={"row"}>
                  <div className="col-md-4 customSelect">
                    <BootstrapField component="select" name="card_month" placeholder="MM">
                      <option value="">MM</option>
                      <option value="01">January</option>
                      <option value="02">February</option>
                      <option value="03">March</option>
                      <option value="04">April</option>
                      <option value="05">May</option>
                      <option value="06">June</option>
                      <option value="07">July</option>
                      <option value="08">August</option>
                      <option value="09">September</option>
                      <option value="10">October</option>
                      <option value="11">November</option>
                      <option value="12">December</option>
                    </BootstrapField>
                    <FontAwesomeIcon icon={faChevronDown} className={"select-arrow"}/>
                    <BootstrapError name="card_month"/>
                  </div>
                  <div className="col-md-1">
                    <span className="form-label">/</span>
                  </div>
                  <div className="col-md-4 customSelect">
                    <BootstrapField component="select" name="card_year" placeholder="YY">
                      <option value="">YY</option>
                      <option value="2018">2018</option>
                      <option value="2019">2019</option>
                      <option value="2020">2020</option>
                      <option value="2021">2021</option>
                      <option value="2022">2022</option>
                      <option value="2023">2023</option>
                      <option value="2024">2024</option>
                      <option value="2025">2025</option>
                      <option value="2026">2026</option>
                      <option value="2027">2027</option>
                      <option value="2028">2028</option>
                      <option value="2029">2029</option>
                      <option value="2030">2030</option>
                      <option value="2031">2031</option>
                      <option value="2032">2032</option>
                    </BootstrapField>
                    <FontAwesomeIcon icon={faChevronDown} className={"select-arrow"}/>
                    <BootstrapError name="card_year"/>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <BootstrapField type="text" name="card_validation_code" placeholder="CVV"/>
                      <BootstrapError name="card_validation_code"/>
                    </div>
                  </div>
                </div>
                <div className={"row"}>
                  {!this.props.alwaysSaveOnFile && 
                  !this.props.isEditing && 
                  <div className="col-md-6">
                    <div className="form-check">
                      <input className="form-check-input rounded-circle" type="checkbox" checked={props.values.save_on_file}
                             id="save_on_file"
                             name={"save_on_file"} onChange={props.handleChange}/>
                      <label className="form-check-label save-on-file-label" htmlFor="save_on_file">
                        Save On File
                      </label>
                    </div>
                  </div>}
                  <div className="col-md-6">
                    {props.values.save_on_file && <div className="form-check">
                      <input className="form-check-input rounded-circle" type="checkbox" checked={props.values.make_default}
                             id="make_default"
                             name={"make_default"} onChange={props.handleChange}/>
                      <label className="form-check-label save-on-file-label" htmlFor="make_default">
                        Set as default
                      </label>
                    </div>}
                  </div>
                </div>
                <div className={"row"}>
                  <div className="col-md-12 text-center">
                    <button className={"btn btn-primary save-card-button"} type="submit"//onClick={this.saveCard}
                            disabled={props.isSubmitting}
                    >{this.buttonText()}
                    </button>
                  </div>
                </div>
              </form>
            )}
          />
        </div>
      </div>
    </div>;
  }

}

AddCreditCardForm.defaultProps = {
  alwaysSaveOnFile: false,
};

AddCreditCardForm.propTypes = {
  payment: PropTypes.object.isRequired,
  save: PropTypes.func.isRequired,
  isEditing: PropTypes.bool.isRequired,
};

export default connect((state, props) => {
  return {
    paymentMethods: state.app.paymentMethods,
  }
})(AddCreditCardForm)

